// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"tooltip__tooltip___2z6GA","tooltipActive":"tooltip__tooltip--active___3_HRN tooltip__tooltip___2z6GA"};